import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41eb69ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "バージョン履歴", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "iPadに対応しました。", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "ブックマーク用のウィジェットのを修正しました。", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Youtubeアプリからの共有処理を修正しました。", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "ウォッチリストへの追加の際にアプリを開かないようにしました。", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "アプリの実行中・非実行中に関わらず、タイマー終了のプッシュ通知が届くようにしました。", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "ウォッチリスト機能を追加しました。", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "ウォッチリストにはブラウザの共有機能などから登録できます。", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "配信を開始しました！", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelloWorld = _resolveComponent("HelloWorld")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_HelloWorld, {
      date: "2024/02/19",
      ver: "1.2.0"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(_component_HelloWorld, {
      date: "2024/02/16",
      ver: "1.1.1"
    }, {
      default: _withCtx(() => [
        _hoisted_5,
        _hoisted_6
      ]),
      _: 1
    }),
    _createVNode(_component_HelloWorld, {
      date: "2024/02/15",
      ver: "1.1.0"
    }, {
      default: _withCtx(() => [
        _hoisted_7,
        _hoisted_8
      ]),
      _: 1
    }),
    _createVNode(_component_HelloWorld, {
      date: "2024/02/09",
      ver: "1.0.0"
    }, {
      default: _withCtx(() => [
        _hoisted_9
      ]),
      _: 1
    })
  ], 64))
}